/**
 * Frontend-side label map for role codes. Insulates UI strings from whatever
 * Keycloak admin happens to have set as the realm-role description, and from
 * the raw enum-style codes (`CUSTOMER_ADMIN`) the backend ships in `OrgData`.
 */
export const ROLE_DISPLAY: Record<string, string> = {
  CUSTOMER_USER: 'Customer User',
  CUSTOMER_ADMIN: 'Customer Admin',
  CUSTOMER_FINANCE: 'Customer Finance',
  CUSTOMER_DEVELOPER: 'Customer Developer',
};

/**
 * Resolve a role code to its display label. Falls back to `fallback` (typical
 * use: the Keycloak description string), then to the code itself.
 */
export const formatRole = (code: string, fallback?: string): string =>
  ROLE_DISPLAY[code] ?? fallback ?? code;
